import GameParameterInterface from '@/models/game/parameters/interface'

interface SelectCardLotteryParameter {
  prize: SelectCardGamePrize
}

interface SelectCardGamePrize {
  prizeImage: string,
  guideUrl: string,
}

export default class SelectCardParameter implements GameParameterInterface {
  constructor(private parameter: SelectCardLotteryParameter) { }

  createSetOption(): SelectCardLotteryParameter {
    return {
      prize: this.parameter.prize,
    }
  }

  get guideUrl(): string {
    return this.parameter.prize.guideUrl
  }
}
